import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Spinner } from 'shared-components';


const GuestSaveStatusDiv = styled.div`
  & .img-error {
    height:0px;
    width:0px;
    -moz-animation: imgErrorAnimation 0.5s ease-out 0.5s forwards;
    -webkit-animation: imgErrorAnimation 0.5s ease-out 0.5s forwards;
    -o-animation: imgErrorAnimation 0.5s ease-out 0.5s forwards;
    animation: imgErrorAnimation 0.5s ease-out 0.5s forwards;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  & .img-success {
    height:28px;
    width:28px;
    -moz-animation: imgSuccessAnimation 0.5s ease-in 2.5s forwards;
    -webkit-animation: imgSuccessAnimation 0.5s ease-in 2.5s forwards;
    -o-animation: imgSuccessAnimation 0.5s ease-in 2.5s forwards;
    animation: imgSuccessAnimation 0.5s ease-in 2.5s forwards;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  & .save-status-spinner {
    height:28px;
    width:28px;
    border-color: rgba(255,255,255,0.2);
    border-bottom-color: #fff;
  }

  @keyframes imgSuccessAnimation {
    to {
        left: 0px;
        width: 0px;
        overflow:hidden;
    }
  }
  @-webkit-keyframes imgSuccessAnimation {
      to {
          left: 0px;
          width: 0px;
          visibility:hidden;
      }
  }

  @keyframes imgErrorAnimation {
    to {
        height: 28px;
        width: 28px;
    }
  }
  @-webkit-keyframes imgErrorAnimation {
      to {
          height: 28px;
          width: 28px;
      }
  }
`;

const renderGuestSaveStatus = (guestSaveStatusStyle) => {
  if (guestSaveStatusStyle.includes('error')) {
    return <img className="img-error" src="/assets/images/error.svg" alt="Error" />;
  }
  if (guestSaveStatusStyle.includes('pending')) {
    return <Spinner className="save-status-spinner" size={1} />;
  }
  if (guestSaveStatusStyle.includes('success')) {
    return <img className="img-success" src="/assets/images/ok.svg" alt="OK" />;
  }
  return null;
};


const GuestListEntryContent = ({ requiredFieldsFilled, guestSaveStatus, cabinSaveStatusOut, cabinSaveStatusHome }) => {
  let guestSaveStatusStyle = '';
  let status = '';
  guestSaveStatusStyle += requiredFieldsFilled ? ' required-fields-complete' : ' required-fields-empty';
  if ((guestSaveStatus === 'PENDING' || cabinSaveStatusOut === 'PENDING' || cabinSaveStatusHome === 'PENDING') && !requiredFieldsFilled) {
    status = ' error';
  } else if ((guestSaveStatus === 'PENDING' || cabinSaveStatusOut === 'PENDING' || cabinSaveStatusHome === 'PENDING') && requiredFieldsFilled) {
    status = ' pending';
  } else if ((guestSaveStatus === 'SUCCESS' || cabinSaveStatusOut === 'SUCCESS' || cabinSaveStatusHome === 'SUCCESS') && requiredFieldsFilled) {
    status = ' success';
  } else if (!requiredFieldsFilled) {
    status = ' error';
  } else if (!guestSaveStatus || !cabinSaveStatusOut || !cabinSaveStatusHome) {
    status = ' initial';
  }
  guestSaveStatusStyle += status;
  return (
    <GuestSaveStatusDiv className={guestSaveStatusStyle}>
      {renderGuestSaveStatus(guestSaveStatusStyle)}
    </GuestSaveStatusDiv>
  );
};

GuestListEntryContent.propTypes = {
  guestSaveStatus: PropTypes.string,
  cabinSaveStatusOut: PropTypes.string,
  cabinSaveStatusHome: PropTypes.string,
  requiredFieldsFilled: PropTypes.bool,
};

export default GuestListEntryContent;



// WEBPACK FOOTER //
// ./src/components/organisms/GuestSaveStatus/index.js